<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div class="generic-form-wrapper component">
    <div
      class="generic-form-wrapper__grid"
      :class="{ '--fullCol': !$slots.image || formSubmitSuccess }"
    >
      <div
        v-if="$slots.image && !formSubmitSuccess"
        class="generic-form-wrapper__image"
      >
        <slot name="image" />
      </div>
      <transition name="fade">
        <div
          v-if="!formSubmitSuccess"
          key="content"
          class="generic-form-wrapper__content"
        >
          <slot />
          <ul
            class="generic-form-wrapper__options-wrapper"
            @click="onCheckboxClick"
            ref="options"
          >
            <slot name="options"></slot>
          </ul>
          <transition name="fade">
            <div
              v-if="hasFormInteraction && isFormDisabled"
              class="generic-form-wrapper__options-disclaimer"
            >
              <slot name="disclaimer"></slot>
            </div>
          </transition>
          <div class="generic-form-wrapper__section">
            <div
              class="generic-form-wrapper__overlay"
              @click="hasFormInteraction = true"
              v-if="isFormDisabled"
            ></div>
            <transition name="fade">
              <div
                class="generic-form-wrapper__form"
                v-if="isFormLoaded"
                :class="{ '--disabled': isFormDisabled }"
              >
                <GenericForm
                  :data="currentFormData"
                  :css-class-form="cssClassForm"
                  :enable-anti-forgery="enableAntiForgeryToken"
                >
                  <div slot="header">
                    <slot name="header"></slot>
                  </div>
                  <div slot="footer">
                    <slot name="footer"></slot>
                  </div>
                </GenericForm>
              </div>
            </transition>
          </div>
        </div>
        <div v-else key="feedback" class="generic-form-wrapper__feedback">
          <slot name="feedback"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GenericForm from '../generic-form/generic-form.vue';
import { eventBus } from 'EventBus/';

export default {
  name: 'generic-form-wrapper',
  props: {
    options: {
      type: Array,
      required: true,
    },
    cssClassForm: {
      type: String,
      required: false,
    },
    enableAntiForgeryToken: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    GenericForm,
  },
  data() {
    return {
      genericFormData: undefined,
      isFormLoaded: false,
      currentFormId: undefined,
      currentFormData: undefined,
      formSubmitSuccess: false,
      isFormDisabled: true,
      hasFormInteraction: false,
    };
  },
  mounted() {
    const children = this.$refs.options.children;
    const firstElement = children[0].querySelector('input');
    this.currentFormId = firstElement.dataset['formId'];
    this.updateCurrentFormData();
    eventBus.$on('form:submitted', this.showFeedbackPage);
  },
  computed: {},
  methods: {
    onCheckboxClick(event) {
      if (event.target.checked) {
        this.isFormDisabled = false;
      }
      event.stopPropagation();
      if (event.target.tagName.toString().toLowerCase() !== 'input') return;

      const newId = event.target.dataset['formId'];
      if (newId === this.currentFormId) return;
      this.currentFormId = newId;
      this.isFormLoaded = false;
      this.updateCurrentFormData();
    },
    updateCurrentFormData() {
      const form = this.options.find((form) => form.id === this.currentFormId);
      this.currentFormData = form.data;
      setTimeout(() => {
        this.isFormLoaded = true;
      }, 500);
    },
    showFeedbackPage() {
      this.formSubmitSuccess = true;
      localStorage.setItem('subscribed', true);
    },
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
